import type { IntlShape } from 'react-intl'

/**
 * Get a user-facing error message based on the HTTP status code
 * returned when loading a chat fails.
 */
export function getChatErrorMessage(intl: IntlShape, errorStatus: number | undefined): string {
  if (errorStatus === 403) {
    return intl.formatMessage({
      id: 'rwKIu5ZmMXZo8aQcE1rM',
      defaultMessage: 'You don\u2019t have access to this chat.',
      description: 'Error message when user lacks permission to view a trip planner chat',
    })
  }
  if (errorStatus === 404) {
    return intl.formatMessage({
      id: 'AWkEjshiaVtIX3WvWZa8',
      defaultMessage: 'This chat no longer exists.',
      description: 'Error message when a trip planner chat has been deleted',
    })
  }
  if (errorStatus === 401) {
    return intl.formatMessage({
      id: 'WlGNGf03-MFDo1bDmqOk',
      defaultMessage: 'Please sign in to view this chat.',
      description: 'Error message when unauthenticated user tries to view a trip planner chat',
    })
  }
  return intl.formatMessage({
    id: 'jz_sicOJsv-O15uHQWVB',
    defaultMessage: 'This chat could not be loaded.',
    description: 'Generic error message when a trip planner chat fails to load',
  })
}

export function getChatErrorHeading(intl: IntlShape): string {
  return intl.formatMessage({
    id: '7UwMzR3Ox-IosoF7mN3u',
    defaultMessage: 'Chat unavailable',
    description: 'Snackbar heading when a trip planner chat cannot be loaded',
  })
}
